import React, { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';

import { Button } from '../../../../core-components/theme/components/Buttons';
import type { ButtonProps } from '../../../../core-components/theme/components/Buttons';

const RouterHref = forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: string }>(function RouterHref(
  { href, ...rest },
  ref,
) {
  return <RouterLink ref={ref} to={href} {...rest} />;
});

export type ButtonLinkProps = Omit<ButtonProps, 'href' | 'onClick' | 'type' | 'LinkComponent'> & { readonly to: string };

export const ButtonLink: React.FC<ButtonLinkProps> = ({ to, ...button }) => <Button {...button} href={to} LinkComponent={RouterHref} />;
